import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const base64ToPdfUrl = (base64String) => {
  // Decode the Base64 string
  const byteCharacters = atob(base64String);
  const byteNumbers = new Array(byteCharacters?.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  // Create a Blob from the byteArray
  const blob = new Blob([byteArray], { type: "application/pdf" });
  return URL.createObjectURL(blob);
};

const App = () => {
  // Example Base64 string (replace with your own)
  const retrievedData = useSelector((state) => state?.formdata);
  // const retrievedData = JSON.parse(sessionStorage.getItem("formdata"));
  console.log("retrievedData", retrievedData);

  const [pdfUrl, setPdfUrl] = useState("");
  // console.log("pdfUrl", pdfUrl);
  // console.log("data---->", retrievedData);
  useEffect(() => {
    const url = base64ToPdfUrl(retrievedData && retrievedData?.phytodocument);
    // console.log("url", url);

    setPdfUrl(url);
  }, []);
  let data = [
    {
      label: "FILE_NAME.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME2.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME3.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME4.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME5.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME6.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME7.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME8.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME9.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME10.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME11.FILE_TYPE",
      files: pdfUrl,
    },
    {
      label: "FILE_NAME12.FILE_TYPE",
      files: pdfUrl,
    },
  ];

  return (
    <div>
      {/* <button onClick={handleShowPdf}>Show PDF</button> */}
      {pdfUrl && (
        <iframe
          src={pdfUrl}
          // type="application/pdf"
          width="100%"
          height="800"
          style={{ border: "none", overflow: "hidden", background: "#fff" }}
        />
      )}
    </div>
  );
};

export default App;
